import CaseStudies from './CaseStudies/CaseStudies';
import MoreInformation from './MoreInformation/MoreInformation';
import Footer from './Footer/Footer';
import Introduction from './Introduction/Introduction';

import './home.css';

function Home() {
  return (
    <div className="home">
      <div className="home__content">
        <h1>ENHANCE</h1>
        <Introduction />
        <CaseStudies />
        <MoreInformation />
      </div>
      <Footer />
    </div>
  );
}

export default Home;
